module.exports = __webpack_public_path__ + "img/796-a99225.png";